export const DASHBOARD_HOME_PERIOD_OPTIONS = [
  { value: 'this_month', label: 'This Month' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'quarter', label: 'This Quarter' },
];

export const DASHBOARD_HOME_TREND_PERIOD_OPTIONS = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
];

export const DASHBOARD_HOME_DISBURSEMENT_VIEW = {
  AMOUNT: 'amount',
  COUNT: 'count',
};

export const DASHBOARD_HOME_DISBURSEMENT_VIEW_OPTIONS = [
  { value: DASHBOARD_HOME_DISBURSEMENT_VIEW.AMOUNT, label: 'Amount' },
  { value: DASHBOARD_HOME_DISBURSEMENT_VIEW.COUNT, label: 'Count' },
];

export const DASHBOARD_HOME_KPI_CARDS = [
  {
    key: 'total_applications',
    title: 'Total Applications',
    value: '2,458',
    changePercent: 12.5,
    comparison: 'vs Apr 2024 (2,184)',
    iconTone: 'blue',
    icon: 'file',
  },
  {
    key: 'applications_approved',
    title: 'Applications Approved',
    value: '1,253',
    changePercent: 10.3,
    comparison: 'Approval Rate 51.0%',
    iconTone: 'green',
    icon: 'user',
  },
  {
    key: 'total_disbursed',
    title: 'Total Disbursed (Amount)',
    value: '₹ 28.75 Cr',
    changePercent: 15.8,
    comparison: 'vs Apr 2024 (₹ 24.82 Cr)',
    iconTone: 'purple',
    icon: 'thunder',
  },
  {
    key: 'total_collected',
    title: 'Total Collected (Amount)',
    value: '₹ 18.32 Cr',
    changePercent: 14.6,
    comparison: 'vs Apr 2024 (₹ 15.99 Cr)',
    iconTone: 'orange',
    icon: 'wallet',
  },
  {
    key: 'active_loans',
    title: 'Active Loans',
    value: '4,126',
    changePercent: 8.7,
    comparison: 'vs Apr 2024 (3,796)',
    iconTone: 'teal',
    icon: 'team',
  },
];

export const DASHBOARD_HOME_PIPELINE_STAGES = [
  {
    key: 'leads',
    label: 'Leads',
    applications: 3456,
    percentOfTotal: 100,
    momChange: 8.2,
    color: '#1e3a5f',
  },
  {
    key: 'app_received',
    label: 'App Received',
    applications: 2458,
    percentOfTotal: 71.1,
    momChange: 12.5,
    color: '#3b82f6',
  },
  {
    key: 'in_review',
    label: 'In Review',
    applications: 1578,
    percentOfTotal: 45.7,
    momChange: 5.4,
    color: '#f59e0b',
  },
  {
    key: 'approved',
    label: 'Approved',
    applications: 1253,
    percentOfTotal: 36.3,
    momChange: 10.3,
    color: '#22c55e',
  },
  {
    key: 'disbursed',
    label: 'Disbursed',
    applications: 1102,
    percentOfTotal: 31.9,
    momChange: 14.9,
    color: '#8b5cf6',
  },
];

export const DASHBOARD_HOME_PIPELINE_CONVERSIONS = [75.5, 64.2, 79.4, 87.9];

export const DASHBOARD_HOME_OVERALL_CONVERSION_RATE = 31.9;

export const DASHBOARD_HOME_PRODUCT_DISBURSEMENT = [
  {
    key: 'term_loan',
    label: 'Term Loan',
    amountLabel: '₹ 11.25 Cr',
    amount: 11.25,
    count: 412,
    percent: 39.1,
    color: '#3b82f6',
  },
  {
    key: 'business_loan',
    label: 'Business Loan',
    amountLabel: '₹ 7.85 Cr',
    amount: 7.85,
    count: 298,
    percent: 27.3,
    color: '#22c55e',
  },
  {
    key: 'personal_loan',
    label: 'Personal Loan',
    amountLabel: '₹ 4.95 Cr',
    amount: 4.95,
    count: 215,
    percent: 17.2,
    color: '#f59e0b',
  },
  {
    key: 'working_capital',
    label: 'Working Capital',
    amountLabel: '₹ 3.65 Cr',
    amount: 3.65,
    count: 128,
    percent: 12.7,
    color: '#8b5cf6',
  },
  {
    key: 'lap',
    label: 'Loan Against Property',
    amountLabel: '₹ 1.05 Cr',
    amount: 1.05,
    count: 49,
    percent: 3.7,
    color: '#ef4444',
  },
];

export const DASHBOARD_HOME_PRODUCT_DISBURSEMENT_TOTAL = {
  amountLabel: '₹ 28.75 Cr',
  amountCaption: 'Total Disbursed',
  countLabel: '1,102',
  countCaption: 'Total Loans',
};

export const DASHBOARD_HOME_TREND_LABELS = [
  "Dec '23",
  "Jan '24",
  "Feb '24",
  "Mar '24",
  "Apr '24",
  "May '24",
];

export const DASHBOARD_HOME_TREND_DISBURSED = [18.2, 19.5, 21.8, 23.4, 24.82, 28.75];
export const DASHBOARD_HOME_TREND_COLLECTED = [12.1, 13.4, 14.8, 15.2, 15.99, 18.32];

export const DASHBOARD_HOME_DISBURSEMENT_SUMMARY = [
  {
    key: 'total',
    label: 'Total Disbursed',
    value: '₹ 28.75 Cr',
    icon: 'wallet',
  },
  {
    key: 'avg_ticket',
    label: 'Average Ticket Size',
    value: '₹ 5.21 Lakh',
    icon: 'tag',
  },
  {
    key: 'loan_count',
    label: 'No. of Loans Disbursed',
    value: '1,102',
    icon: 'file',
  },
  {
    key: 'growth',
    label: 'Disbursement Growth MoM',
    value: '15.8%',
    icon: 'rise',
    isGrowth: true,
  },
];

export const DASHBOARD_HOME_COLLECTION_SUMMARY = [
  {
    key: 'total',
    label: 'Total Collected',
    value: '₹ 18.32 Cr',
    icon: 'wallet',
  },
  {
    key: 'efficiency',
    label: 'Collection Efficiency',
    value: '63.7%',
    icon: 'percent',
  },
  {
    key: 'accounts',
    label: 'No. of Accounts Collected',
    value: '3,247',
    icon: 'team',
  },
  {
    key: 'growth',
    label: 'Collection Growth MoM',
    value: '14.6%',
    icon: 'rise',
    isGrowth: true,
  },
];

export const DASHBOARD_HOME_TOP_PRODUCTS = [
  {
    key: 'lap',
    product: 'Loan Against Property',
    disbursed: 1.05,
    collected: 0.87,
    efficiency: 82.9,
  },
  {
    key: 'term_loan',
    product: 'Term Loan',
    disbursed: 11.25,
    collected: 8.12,
    efficiency: 72.2,
  },
  {
    key: 'business_loan',
    product: 'Business Loan',
    disbursed: 7.85,
    collected: 5.14,
    efficiency: 65.5,
  },
  {
    key: 'working_capital',
    product: 'Working Capital',
    disbursed: 3.65,
    collected: 2.28,
    efficiency: 62.5,
  },
  {
    key: 'personal_loan',
    product: 'Personal Loan',
    disbursed: 4.95,
    collected: 1.91,
    efficiency: 38.6,
  },
];

export const DASHBOARD_HOME_RECENT_DISBURSEMENTS = [
  {
    key: '1',
    applicationId: 'APP-2024-05231',
    customerName: 'Ramesh Kumar',
    product: 'Term Loan',
    amount: '₹ 15,00,000',
    date: '31 May 2024',
    status: 'Disbursed',
  },
  {
    key: '2',
    applicationId: 'APP-2024-05218',
    customerName: 'Shree Enterprises',
    product: 'Business Loan',
    amount: '₹ 25,00,000',
    date: '30 May 2024',
    status: 'Disbursed',
  },
  {
    key: '3',
    applicationId: 'APP-2024-05205',
    customerName: 'Priya Sharma',
    product: 'Personal Loan',
    amount: '₹ 5,00,000',
    date: '29 May 2024',
    status: 'Disbursed',
  },
  {
    key: '4',
    applicationId: 'APP-2024-05192',
    customerName: 'ABC Traders',
    product: 'Working Capital',
    amount: '₹ 12,00,000',
    date: '28 May 2024',
    status: 'Disbursed',
  },
  {
    key: '5',
    applicationId: 'APP-2024-05178',
    customerName: 'Vikram Singh',
    product: 'Loan Against Property',
    amount: '₹ 45,00,000',
    date: '27 May 2024',
    status: 'Disbursed',
  },
];

export const DASHBOARD_HOME_APPLICATIONS_BY_STAGE = [
  { key: 'leads', label: 'Leads', value: 3456, color: '#1e3a5f' },
  { key: 'app_received', label: 'App Received', value: 2458, color: '#3b82f6' },
  { key: 'in_review', label: 'In Review', value: 1578, color: '#f59e0b' },
  { key: 'approved', label: 'Approved', value: 1253, color: '#22c55e' },
  { key: 'disbursed', label: 'Disbursed', value: 1102, color: '#8b5cf6' },
];

export const DASHBOARD_HOME_EFFICIENCY_THRESHOLDS = {
  HIGH: 70,
  MEDIUM: 50,
};
